import React from 'react';
import { LazyRouteToRightEditor } from '@confluence-classic/confluence-fabric-editor/src/components/RouteToRightEditor/LazyRouteToRightEditor.js';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { getUniquePageLoadId } from '@confluence/unique-page-load-id/entry-points/UniquePageLoadId.ts';

import { navdexEnd } from '../naxdev.js';

export const EditPageRoute = ({ params: { contentId, spaceKey } }: RouteMatch) => (
	<LazyRouteToRightEditor contentType="pages" contentId={contentId} spaceKey={spaceKey} />
);

EditPageRoute.NAVIGATION_PARAMS = ({ params: { contentId, spaceKey } }: RouteMatch) => ({
	Screen: {
		showPremiumOnboarding: false,
		screenEvent: {
			name: 'editPageScreen',
			id: contentId,
			attributes: {
				...navdexEnd.attributes,
				pageLoadInfo: getUniquePageLoadId(),
			},
		},
		pageState: { contentId, spaceKey },
	},
	MainLayout: false,
});
